import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Grid from "@material-ui/core/Grid";
import { Link } from "react-router-dom";
import ColAtm from "../../../../../atomic/Col/Col";
import OverFlowText from "../../../../../molecules/OverFlowText/OverFlowText";
import BlockAtm from "../../../../../atomic/Block/Block";
import { getProperty } from "../../../../../../utils";
import axios from "axios";
import { getAppLang } from "../../../../../../utils";
import { getLanguages } from "../../../../../../redux/actions/languageActions";
import { getGoogleRating, clearGoogleRating } from "../../../../../../redux/actions/General/GoogleRating/googleRatingActions";
import { WEB_EDIT_SHORT } from '../../../../../../constants/appUrls.constants';
import { GET_WEB, SYNC_THIRD_PARTY_COMPONENTS, GET_THIRD_PARTY_COMPONENTS } from '../../../../../../constants/api.constants';
import { PageTitle } from '../../../../../atomic/PageHeader/PageTitle';
import { useTranslation } from 'react-i18next';
import PageHeaderAtm from '../../../../../atomic/PageHeader/PageHeader';
import { WEB } from "../../../../../../constants/appUrls.constants";
import { Animated } from "react-animated-css";
import Container from "@material-ui/core/Container";
import { Dialog, DialogContent, Typography, MenuItem, FormControlLabel, Checkbox } from '@material-ui/core';
import MuiDialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import ButtonAtm from '../../../../../atomic/Button/Button';
import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from '@material-ui/icons/Close';
import { SelectValidator } from 'react-material-ui-form-validator';
import {Select, InputLabel, OutlinedInput, Box, Chip} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormControl from '@material-ui/core/FormControl';

const styles = theme => ({
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon className="close-button" />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

export default function ThirdPartyComponentsBox() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const languageList = useSelector(props => props.languagesReducer?.languages);
  const googleRating = useSelector(props => props.googleRatingReducer?.data?.data);

  const [backUrl, setBackUrl] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [language, setLanguage] = useState([]);
  const [getComponents, setGetComponents] = useState([]);
  const [getId, setGetId] = useState(null);
  const [value, setValue] = useState({});
  const [componentField, setComponentField] = useState("");
  const [componentName, setComponentName] = useState("");
  const [componentParamName, setComponentParamName] = useState("");
  const [componentKey, setComponentKey] = useState("");
  const [showRating, setShowRating] = useState(true);
  const [loading, setIsLoading] = useState(false);

  useEffect(() => {
    dispatch(getLanguages());
  }, [dispatch]);

  useEffect(() => {
    getComponentList();
  }, []);

  useEffect(() => {
    getBackUrl();
  }, []);

  useEffect(() => {
    if (modalOpen && componentKey === 'googlereview' && showRating) {
      dispatch(getGoogleRating());
    }
  }, [modalOpen, componentKey, showRating, dispatch]);

  useEffect(() => {
    if (!modalOpen) {
      dispatch(clearGoogleRating());
    }
  }, [modalOpen, dispatch]);
  
  const getBackUrl = () => {
    const params = {
      params: {
          property_id: getProperty(),
      }
    }
    axios.post(GET_WEB, params, {
        headers: {
            "Accept": "application/json",
            authToken: localStorage.getItem('auth'),
            "Content-Type": "application/json",
            "language": getAppLang(),
        }
    }).then((result) => {
        if(result.data.data.status){
            setBackUrl(result.data.data.id)
        } else {
            setBackUrl(null)
        }
    }).catch(function (error) {
        console.log(error);
    });
  }

  const getComponentList = () => {
    const params = {
      params: {
        property_id: getProperty(),
        channel_id: 1
      }
    }

    axios.post(GET_THIRD_PARTY_COMPONENTS, params, {
      headers: {
        "Accept": "application/json",
        authToken: localStorage.getItem('auth'),
        "Content-Type": "application/json",
        "language": getAppLang(),
      }
    }).then((result) => {
      setGetComponents(result.data.data)
    }).catch(function (error) {
      console.log(error);
    });
  }

  const syncComponents = (component_id, value, langs) => {
    const params = {
      params: {
        property_id: getProperty(),
        channel_id: 1,
        component_id: component_id,
        componentDetail: {
          parameter: value,
        //   language: { code: langs }
         language: langs !== undefined ? langs.map((lang) => ({ code: lang })) : null,
        },
        is_selected: true,
      }
    }

    axios.post(SYNC_THIRD_PARTY_COMPONENTS, params, {
      headers: {
        "Accept": "application/json",
        authToken: localStorage.getItem('auth'),
        "Content-Type": "application/json",
        "language": getAppLang(),
      }
    }).then((result) => {
      setModalOpen(false);
      getComponentList(); 
      setTimeout(() => {
        window.location.reload();
      }, 100);
    }).catch(function (error) {
      console.log(error);
    });
  }

  const openModal = (e) => {
    setModalOpen(true);
    setGetId(parseInt(e.currentTarget.id));

    getComponents.filter((checkId) => checkId?.id === parseInt(e.currentTarget.id)).map((item) => {
      setComponentName(item?.name);
      setComponentParamName(item?.parameterArray);
      setComponentField(Object.keys(item?.parameterArray));
      setComponentKey(item?.component);
      const hasPlaceId = !!item?.componentDetail?.parameterArray?.placeId;
      setShowRating(item?.is_selected && hasPlaceId ? (item?.componentDetail?.parameterArray?.showRating ?? true) : false);
      const tempLangs = item?.componentDetail?.languageArray;

      const currentLangs = tempLangs?.map((item) => Object.values(item).toString());
      setLanguage(currentLangs)

      let initialValues = {};
      Object.keys(item?.parameterArray).forEach(key => {
        initialValues[key] = item?.componentDetail?.parameterArray[key] || '';
      });
      setValue(initialValues);
    });
  }

  const setParameterValue = (e, key) => {
    const newValue = { ...value, [key]: e.target.value };
    setValue(newValue);
  }

  const submitComponent = (e) => {
    e.preventDefault();
    const finalValue = componentKey === 'googlereview' ? { ...value, showRating } : value;
    syncComponents(getId, finalValue, language);
  }

  const selectLang = ({ target }) => {
    setLanguage([]);
    setLanguage(target.value);
  };

  const onModalClose = (e) => {
    setModalOpen(false);
  }

  const setActive = (e) => {
    const componentId = parseInt(e.currentTarget.id);
    const currentComponent = getComponents.find((component) => component.id === componentId);
    const newIsSelectedValue = !currentComponent.is_selected;

    if (currentComponent.is_selected === false) {
        setModalOpen(true);
        getComponents.filter((checkId) => checkId?.id === componentId).map((item) => {
          setGetId(parseInt(e.currentTarget.id));
          setComponentName(item?.name);
          setComponentParamName(item?.parameterArray);
          setComponentField(Object.keys(item?.parameterArray));
          setComponentKey(item?.component);
          const hasPlaceId = !!item?.componentDetail?.parameterArray?.placeId;
          setShowRating(item?.is_selected && hasPlaceId ? (item?.componentDetail?.parameterArray?.showRating ?? true) : false);
          const tempLangs = item?.componentDetail?.languageArray;

          const currentLangs = tempLangs?.map((item) => Object.values(item).toString());
          setLanguage(currentLangs)
          
          let initialValues = {};
          Object.keys(item?.parameterArray).forEach(key => {
            initialValues[key] = item?.componentDetail?.parameterArray[key] || '';
          });
          setValue(initialValues);
      
        })
    } else {
      setIsLoading(true);
        const params = {
          params: {
            property_id: getProperty(),
            channel_id: 1,
            component_id: componentId,
            is_selected: newIsSelectedValue,
            componentDetail: null,
          }
        };
      
        axios.post(SYNC_THIRD_PARTY_COMPONENTS, params, {
          headers: {
            "Accept": "application/json",
            authToken: localStorage.getItem('auth'),
            "Content-Type": "application/json",
            "language": getAppLang(),
          }
        }).then((result) => {
            getComponentList();
            setIsLoading(false);
        }).catch(function (error) {
          console.log(error);
        });
    }
  };

  return (
    <div>
      <PageTitle title={t('btn-third_party_components_list')} />
      <PageHeaderAtm exitText={t('enw-web-edit-page_title')} text={t('btn-third_party_components_list')} backButton={backUrl === null ? WEB : WEB_EDIT_SHORT + backUrl} />
      <Animated animationIn="bounceInRight" animationInDuration={1000} isVisible={true}>
        <Container maxWidth="xl">
          <div className="container-width pb-0">
            {getComponents.length > 0 &&
              getComponents.map((component, index) => (
                <Grid item className="offer-fact-col pos-relative d-inline-block" xs={6} sm={4} md={2} key={component.id}>
                  {component?.is_selected && (
                    <ButtonAtm
                      id={component?.id}
                      className="btn-tpc edit-channel-price-btn"
                      endIcon={<i className="fas fa-edit" />}
                      onClick={openModal}
                      title={t('btn-update')}
                    />
                  )}
                  <BlockAtm id={component?.id} onClick={setActive} className="offer-fact-border-box fact-border-box">
                    <label className={component?.is_selected ? "active-pos channel-logo-bg" : "passive-pos"}>
                      <Grid item xs={12} className="cancellation-info-col">
                        <ColAtm className="channel-logo pos-relative">
                          <label>
                            {
                              loading &&
                              <CircularProgress size={44} style={{left:"40%", color: "#d71f26"}} />
                            }
                            <img src={component?.iconUrl} style={{ width: "145px", height: "95px" }} alt={component?.name} />
                          </label>
                        </ColAtm>
                      </Grid>
                      <OverFlowText>{component?.name}</OverFlowText>
                    </label>
                  </BlockAtm>
                </Grid>
              ))}
            <Dialog onClose={onModalClose} aria-labelledby="status" open={modalOpen} className="web-preview-dialog">
              <DialogTitle className="red-bottom-border" id="status" onClose={onModalClose}>{componentName}</DialogTitle>
              <DialogContent>
                <ValidatorForm onSubmit={submitComponent} className="w-100">
                  <Grid container className="p-24 cover-vid-modal payment-create-dialog">
                    <BlockAtm md={12}>
                      <p className="f-w-600">{t('enw-edit-third_party_component')}</p>
                    </BlockAtm>
                    {componentField?.length > 0 &&
                      componentField.map((key) => (
                        <Grid item xs={12} md={componentField?.length > 1 ? 6 : 12} key={key} className="mb-12">
                          <TextValidator
                            name={key}
                            className="form-control mt-12-cvr"
                            type="text"
                            fullWidth
                            value={value[key] || ''}
                            variant="outlined"
                            label={componentParamName[key]?.name || ''}
                            autoComplete="off"
                            onChange={(e) => setParameterValue(e, key)}
                            // required
                            validators={['required']}
                            errorMessages={[ t("enw-notification_this_is_required") ]}
                          />
                        </Grid>
                      ))}
                    <Grid item xs={12} md={12} className='mb-12'>
                      <FormControl style={{width:"100%"}} className='mt-0'>
                      <InputLabel style={{margin:"6px 0px 0px 12px"}} id="languageSelector">{t('enw-input-language')}</InputLabel>
                      <Select
                        // label={t('enw-input-language')}
                        labelId="languageSelector"
                        className="form-control mt-12-cvr"
                        onChange={selectLang}
                        value={language || []}
                        multiple
                        fullWidth
                        input={<OutlinedInput id="select-multiple-chip" defaultValue={""} label={t('enw-input-language')} />}
                        renderValue={(selected) => (
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 5.5 }}>
                              {selected.map((value) => (
                                <Chip key={value} label={languageList.filter((filter) => filter?.code === value).map((item) => t(item?.language_key))} />
                              ))}
                            </Box>
                          )}
                        defaultValue={[]}
                        >
                        {languageList?.map((lang) => (
                          <MenuItem value={lang.code} key={lang.code}>
                            <img src={`/assets/img/language/${lang.code}.svg`} alt="en" style={{ width: 20, marginRight: 8 }} /> {t(lang.language_key)}
                        </MenuItem>
                        ))}
                    </Select>
                    </FormControl>
                    </Grid>
                    {componentKey === 'googlereview' && (
                      <Grid item xs={12} md={12} className='mb-12'>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={showRating}
                              onChange={(e) => setShowRating(e.target.checked)}
                              color="primary"
                              disabled={!value?.placeId}
                            />
                          }
                          label={<span style={{ fontSize: '14px' }}>{t('enw-show_google_rating_on_website')}</span>}
                        />
                        {showRating && googleRating && (
                          <div className="d-flex align-items-center" style={{ gap: '6px', marginLeft: '12px', alignItems: 'center' }}>
                            <span style={{ fontSize: '16px', fontWeight: 600, color: '#202124' }}>
                              {googleRating.google_rating}
                            </span>
                            <span style={{ display: 'inline-flex', color: '#fbbc04' }}>
                              {[1, 2, 3, 4, 5].map((star) => (
                                <i
                                  key={star}
                                  className={star <= Math.round(googleRating.google_rating) ? 'fas fa-star' : 'far fa-star'}
                                  style={{ fontSize: '14px' }}
                                />
                              ))}
                            </span>
                            {googleRating.google_rating_total != null && (
                              <span style={{ fontSize: '13px', color: '#70757a' }}>
                                ({googleRating.google_rating_total})
                              </span>
                            )}
                          </div>
                        )}
                      </Grid>
                    )}
                    <ColAtm className="mt-32" md={12}>
                      <ButtonAtm
                        className="m-auto room-rate-modal-save bg-red"
                        buttontext={t('btn-save')}
                        color="primary"
                        type="submit"
                      />
                    </ColAtm>
                  </Grid>
                </ValidatorForm>
              </DialogContent>
            </Dialog>
          </div>
        </Container>
      </Animated>
    </div>
  );
}
